<template>
  <div class="wrapper">


    <div class="invoice-head-title">
      <div>
        发票信息
      </div>
      <div v-if="this.invoiceTitle==''" class="edit-button" @click="editInvoiceInfo">
        新增发票信息
      </div>
      <div v-if="this.invoiceTitle!=''" class="edit-button" @click="editInvoiceInfo">
        修改发票信息
      </div>
    </div>
    <div class="head-wrapper">
      <div v-if="this.invoiceTitle!=''" class="invoice-wrapper">

        <div v-if="this.invoiceTitle" class="content-wrapper">
          <div class="title">发票抬头</div>
          <div class="content">{{ this.invoiceTitle }}</div>
        </div>

        <div v-if="this.invoiceTitle" class="content-wrapper">
          <div class="title">开具类型</div>
          <div class="content">{{ this.invoiceTitle == "" ? "" : (this.radio_type == 0 ? "个人" : "企业") }}</div>
        </div>

        <div v-if="this.invoiceTitle" class="content-wrapper">
          <div class="title">发票类型</div>
          <div class="content">{{ this.invoiceTitle == "" ? "" : (this.radio == 0 ? "增值税普通发票" : "增值税专用发票") }}</div>
        </div>

        <div v-if="this.bankAccount" class="content-wrapper">
          <div class="title">统一社会信用代码</div>
          <div class="content">{{ this.bankAccount }}</div>
        </div>

        <div v-if="this.bankName" class="content-wrapper">
          <div class="title">基本开户银行名称</div>
          <div class="content">{{ this.bankName }}</div>
        </div>

        <div v-if="this.bankAccount" class="content-wrapper">
          <div class="title">基本开户账号</div>
          <div class="content">{{ this.bankAccount }}</div>
        </div>
        <div v-if="this.registerAddress" class="content-wrapper">
          <div class="title">注册场所地址</div>
          <div class="content">{{ this.registerAddress }}</div>
        </div>
        <div v-if="this.registerPhone" class="content-wrapper">
          <div class="title">注册固定电话</div>
          <div class="content">{{ this.registerPhone }}</div>
        </div>
      </div>
      <div v-if="this.invoiceTitle==''" class="no-invoice">未添加发票信息</div>
    </div>

    <div class="center">
      <div class="invoice-head-title">
        <span>寄送地址</span>
        <span>最多可存3条地址</span>
      </div>

      <el-row>
        <el-button type="primary" @click="handleEdit">新增地址</el-button>
      </el-row>

    </div>

    <div class="form-wrapper">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column label="序号" align="center" type="index" width="60">
        </el-table-column>
        <el-table-column prop="userName" label="收货人" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="userPhone" label="电话号码" width="150" show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="areaPath" label="所在地区" width="150" show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="address" label="街道地址" width="210" show-overflow-tooltip>
        </el-table-column>


        <el-table-column align="center" label="操作" min-width="300">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteAddress(scope.$index, scope.row)">删除</el-button>
            <el-tag v-if="scope.row.isDefault" size="small" type="primary" prop="show" style="margin-left: 1vw">默认地址
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="addressDialogFormVisible" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm">
        <el-form-item label="收件人姓名" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入收件人姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="name">
          <el-input size="small" v-model="editForm.phone" auto-complete="off" placeholder="请输入手机号码"></el-input>
        </el-form-item>

        <el-form-item label="所在地区" prop="name">
          <el-cascader size="large" :options="options" v-model="selectedOptions" @change="handleChange"
                       style="width: 100%"
                       placeholder="选择所在地区">
          </el-cascader>
        </el-form-item>

        <el-form-item label="街道地址" prop="name">
          <el-input size="small" v-model="editForm.address" auto-omplete="off" placeholder="请输入街道地址"></el-input>
        </el-form-item>

        <el-form-item label="默认地址" prop="name">

          <el-radio v-model="editForm.isDefault" label="1">是</el-radio>
          <el-radio v-model="editForm.isDefault" label="0" :disabled="checkDisabled">否
          </el-radio>

        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addressDialogFormVisible=false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :title="this.invoiceTitle==''?'新增发票信息':'修改发票信息'" :visible.sync="invoiceDialogFormVisible">
      <el-form label-width="8vw">
        <el-form-item label="开具类型">
          <el-radio v-model="radio_type" label="0">个人</el-radio>
          <el-radio v-model="radio_type" label="1">企业</el-radio>

        </el-form-item>
        <el-form-item label="发票抬头">
          <el-input v-model="invoiceTitle" autocomplete="off" placeholder="请填写发票抬头"></el-input>
        </el-form-item>
        <el-form-item label="发票类型">
          <el-radio v-model="radio" label="0">增值税普通发票</el-radio>
          <el-radio v-model="radio" label="1" v-if="radio_type==1">增值税专用发票</el-radio>
        </el-form-item>
        <el-form-item v-if="radio_type==1" label="统一社会信用代码">
          <el-input v-model="code" autocomplete="off" placeholder="请填写统一社会信用代码"></el-input>
        </el-form-item>
        <el-form-item v-if="radio_type==1" label="基本开户银行名称">
          <el-input v-model="bankName" autocomplete="off" placeholder="请填写您开户许可证上的开户银行"></el-input>
        </el-form-item>
        <el-form-item v-if="radio_type==1" label="基本开户账号">
          <el-input v-model="bankAccount" autocomplete="off" placeholder="请填写您开户许可证上的银行账号"></el-input>
        </el-form-item>
        <el-form-item v-if="radio_type==1" label="注册场所地址">
          <el-input v-model="registerAddress" autocomplete="off" placeholder="请填写您营业执照上的注册地址"></el-input>
        </el-form-item>
        <el-form-item v-if="radio_type==1" label="注册固定电话">
          <el-input v-model="registerPhone" autocomplete="off" placeholder="请填写您公司有效的联系电话"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="invoiceDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveInvoiceInformation">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>

import {regionData, CodeToText, TextToCode} from "element-china-area-data";
import {addOrUpdateInvoice, getInvoice, addAddress, getAddress, delAddress} from "../../api/payMG";

export default {
  data() {
    return {
      formLabelAlign: {
        name: '',
        region: '',
        type: '',
        company: '',
        url: '',
        phone: '',
        email: '',
        profession: '',
        nickName: ''
      },
      checkDisabled: false,
      options: regionData,
      selectedOptions: [],
      invoiceDialogFormVisible: false,
      addressDialogFormVisible: false,

      invoiceTitle: "",
      radio_type: "0",
      radio: "0",
      code: "",
      bankName: "",
      bankAccount: "",
      registerAddress: "",
      registerPhone: "",

      phoneNumber: "",
      checkCode: "",
      listData: [], //用户数据

      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',

      editForm: {
        id: '',
        name: '',
        area: '',
        address: '',
        phone: '',
        isDefault: "1",
        areaIds: ""
      },

    }
  },
  // 注册组件
  components: {},

  /**
   * 数据发生改变
   */
  watch: {
    radio_type: {
      handler(newValue, oldValue) {
        if (newValue == "0") {
          this.radio = "0"
        }
      },
      immediate: true
    }

  },

  /**
   * 创建完毕
   */
  created() {
    this.getInvoiceInfo(this.$store.getters.getUserInfo.userId)
    this.getAddressList(this.$store.getters.getUserInfo.userId);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleChange() {
      let loc = "";
      for (let i = 0; i < this.selectedOptions.length; i++) {
        loc += CodeToText[this.selectedOptions[i]];
      }
      this.editForm.area = loc;
      this.editForm.areaIds = this.selectedOptions.toString();
    },

    checkPhone(num) {
      let tel = /^0\d{2,3}-?\d{7,8}$/;
      let phone = /^1[3456789]\d{9}$/;

      if (num.length == 11) {//手机号码
        if (phone.test(num)) {
          return true;
        }
      } else if (num.length == 13 && num.indexOf("-") != -1) {//电话号码
        if (tel.test(num)) {
          return true;
        }
      }
      return false;
    },


    editInvoiceInfo() {
      this.invoiceDialogFormVisible = true;
    },

    //显示编辑界面
    handleEdit: function (index, row) {
      debugger
      console.log(row)
      this.addressDialogFormVisible = true

      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.name = row.userName
        this.editForm.area = row.areaPath
        this.editForm.address = row.address
        this.editForm.phone = row.userPhone
        this.editForm.isDefault = row.isDefault + ""
        this.editForm.addressId = row.addressId;

        this.selectedOptions = row.areaIds.split(",")

        if (this.listData.length <= 1) {
          this.checkDisabled = true;
        } else {
          this.checkDisabled = false;
        }
        console.log(this.selectedOptions)

      } else {
        this.title = '添加'
        this.editForm.name = ""
        this.editForm.area = ""
        this.editForm.address = ""
        this.editForm.phone = ""
        this.editForm.Default = "1"
        this.editForm.addressId = ""
        this.selectedOptions = []
        if (this.listData.length < 1) {
          this.checkDisabled = true;
        } else {
          this.checkDisabled = false;
        }
      }
    },
    // 编辑、增加页面保存方法
    submitForm() {

      let that = this;

      if (this.editForm.name == "") {
        this.$message.warning("请输入收件人姓名")
        return;
      }
      if (this.editForm.phone == "") {
        this.$message.warning("请输入收件人电话")
        return;
      }

      if (!this.checkPhone(this.editForm.phone)) {
        this.$message.warning("请输入正确的号码")
        return;
      }

      if (this.editForm.areaPath == "") {
        this.$message.warning("请选择区域")
        return;
      }
      if (this.editForm.address == "") {
        this.$message.warning("请填写详细的地址信息")
        return;
      }

      addAddress(
        {
          "userId": this.$store.getters.getUserInfo.userId,
          "userName": this.editForm.name,
          "userPhone": this.editForm.phone,
          "areaPath": this.editForm.area,
          "address": this.editForm.address,
          "isDefault": this.editForm.isDefault,
          "addressId": this.editForm.addressId,
          "areaIds": this.selectedOptions.toString()
        }
      ).then(response => {

        if (response.status != 200) {
          that.$message.warning(response.message)
        } else {
          that.$message.success("保存成功")
          that.addressDialogFormVisible = false
          that.getAddressList(this.$store.getters.getUserInfo.userId)
        }

      }).catch(e => {
          console.log(e);
          that.$message.warning("网络异常，请稍后重试！")
        }
      )

      console.log(this.editForm)
    },

    // 删除地址
    deleteAddress(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delAddress(
            {
              "userId": this.$store.getters.getUserInfo.userId,
              "addressId": row.addressId
            }
          )
            .then(res => {
              if (res.status == 200) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getAddressList(this.$store.getters.getUserInfo.userId);
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络异常，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    saveInvoiceInformation() {

      if (this.invoiceTitle == '') {
        this.$message.warning("请填写发票抬头")
        return;
      }

      if (this.radio_type == 1) {
        if (this.code == '') {
          this.$message.warning("请填写统一社会信用代码")
          return;
        }
      }

      if (this.radio == 2) {

        if (this.bankName == '') {
          this.$message.warning("请填写开户银行名称")
          return;
        }

        if (this.bankAccount == '') {
          this.$message.warning("请填写开户银行账号")
          return;
        }
        if (this.registerAddress == '') {
          this.$message.warning("请填写场所注册地址")
          return;
        }
        if (this.registerPhone == '') {
          this.$message.warning("请填写固定电话号码")
          return;
        }
      }

      let that = this;
      addOrUpdateInvoice(
        {
          "invoiceHead": this.invoiceTitle,
          "invoiceCode": this.code,
          "userId": this.$store.getters.getUserInfo.userId,
          "type": this.radio_type,
          "invoiceType": this.radio,
          "invoiceAddr": this.registerAddress,
          "invoiceBankName": this.bankName,
          "invoiceBankNo": this.bankAccount,
          "invoicePhone": this.registerPhone
        }
      ).then(response => {


        if (response.status != 200) {
          that.$message.warning(response.message)
        } else {
          that.invoiceDialogFormVisible = false
          that.getInvoiceInfo(this.$store.getters.getUserInfo.userId);

        }

        console.log(response);

      }).catch(e => {
        console.log(e)
        that.$message.warning("网络异常，请稍后重试")
      })

    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    getInvoiceInfo(userId) {
      let that = this;
      getInvoice(userId).then(response => {

        if (response.status == 200) {

          that.invoiceTitle = response.data.invoiceHead;
          that.code = response.data.invoiceCode
          that.radio_type = response.data.type + ""
          that.radio = response.data.invoiceType + ""
          that.registerAddress = response.data.invoiceAddr
          that.bankName = response.data.invoiceBankName
          that.bankAccount = response.data.invoiceBankNo
          that.registerPhone = response.data.invoicePhone
        }
      }).catch(e => {
        console.log(e)
        that.$message.warning("网络异常，请稍后重试")
      })
    },

    getAddressList(userId) {
      let that = this;
      getAddress(userId).then(response => {

        if (response.status != 200) {
          that.$message.warning(response.message);
        } else {
          that.listData = response.data;
        }

      }).catch(e => {
        console.log(e)
        that.$message.warning("网络异常，请稍后重试")
      })
    }

  }

}
</script>

<style scoped>
.wrapper {
  margin: 0 2vw;
}

.head-wrapper {
  background-color: white;

}

.head-wrapper .no-invoice {
  height: 30vw;
  text-align: center;
  margin: auto 0;
  line-height: 30vw;
}

.invoice-head {
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-content: center;
}

.invoice-wrapper {
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: 0 3vw;
  font-size: 0.9vw;
}

.invoice-wrapper .content-wrapper {
  display: flex;
  justify-content: left;
  align-items: center;
}


.invoice-head-title {
  font-size: 1.0vw;
  margin: 1vw 0;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
}

.invoice-head-title .edit-button {
  color: #3a8ee6;
  cursor: pointer;
}


.content-wrapper .title {
  margin: 1vw 4vw 1vw 1vw;
  width: 12vw;
}

.form-wrapper {
  background-color: #ffffff;
  height: 10vw;
}

.form {
  padding-top: 3vw;
  width: 30vw;
}

.center {
  display: flex;
  justify-content: space-between;
  margin: 1vw;
  height: 3vw;
}

.center span:first-child {
  font-size: 1.0vw;
  height: 100%;
  line-height: 1.5vw;
}

.center span:last-child {
  font-size: 0.8vw;
  height: 100%;
  line-height: 1.5vw;
  margin-left: 0.5vw;
  color: gray;
}

</style>






// WEBPACK FOOTER //
// src/views/pay/Invoice.vue